import {
  FormControlLabel,
  ListSubheader,
  Menu,
  MenuItem,
  Radio,
} from "@mui/material";
import React, { Dispatch, SetStateAction, useCallback } from "react";
import {
  GroupRole,
  PatientGroupRoles,
  setPersistentGroupRole,
} from "../features/slices/authSlice";
import { LabelingRole } from "../features/api/labelApiSlice";
import { apiSlice, logOutHelper } from "../features/api/apiSlice";
import { useAppDispatch } from "../features/store";
import { useNavigate } from "react-router";

const GroupRoleMenu = (props: {
  menuAnchor: HTMLElement | null;
  setMenuAnchor: Dispatch<SetStateAction<HTMLElement | null>>;
  patientGroupRoles: PatientGroupRoles;
  persistent?: GroupRole;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { menuAnchor, setMenuAnchor, patientGroupRoles, persistent } = props;

  const sortedEntries = React.useMemo(
    () => Object.entries(patientGroupRoles).sort(),
    [patientGroupRoles]
  );

  const handlePatientGroupRoleClick = useCallback(
    (groupRole: GroupRole) => {
      dispatch(setPersistentGroupRole(groupRole));
      setMenuAnchor(null);
      logOutHelper(dispatch, apiSlice.util.resetApiState);
      navigate("/", { replace: true });
    },
    [dispatch, setMenuAnchor, navigate]
  );

  const handleMenuClose = useCallback(
    (e: UIEvent) => {
      setMenuAnchor(null);
      e.stopPropagation();
    },
    [setMenuAnchor]
  );

  return (
    <Menu
      anchorEl={menuAnchor}
      open={menuAnchor != null}
      onClose={handleMenuClose}
      slotProps={{
        list: { role: "listbox" },
        transition: { timeout: 0 },
      }}
    >
      {sortedEntries.map(([group, roles]) => (
        <div key={group}>
          <ListSubheader sx={{ fontSize: "1rem" }}>{group}</ListSubheader>
          {roles.map((role: LabelingRole) => (
            <MenuItem key={role}>
              <FormControlLabel
                value={{ group, role }}
                label={role}
                onChange={() => {
                  handlePatientGroupRoleClick({ group, role });
                }}
                control={
                  <Radio
                    checked={
                      persistent?.role === role && persistent.group === group
                    }
                  />
                }
              />
            </MenuItem>
          ))}
        </div>
      ))}
    </Menu>
  );
};

export default GroupRoleMenu;
